import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Icon } from "@/shared/ui";

type Props = {
  days: number;
  i18FileName: string;
  children: ReactNode;
  dataMzAccent?: string;
};

function FeeSuccess({ days, i18FileName, dataMzAccent, children }: Props) {
  const { t } = useTranslation(i18FileName);
  return (
    <div className="flex flex-col gap-5" data-mz-accent={dataMzAccent}>
      <div className="flex items-center justify-between">
        <div
          className="text-15 font-medium text-gray/50"
          dangerouslySetInnerHTML={{
            __html: t(`${i18FileName}.fee.prepaidDays`, { days }),
          }}
        />
        {children}
      </div>
      <div
        className={clsx(
          "h-[2.75rem] flex items-center justify-center gap-2.5 bg-gradient-to-tr from-accent-solid/10 to-accent-muted/10 text-accent-solid",
          "rounded-[0.5rem] border border-dashed border-accent-solid",
        )}
      >
        <Icon name="rub" className="w-6" />
        <div className="text-12 font-bold uppercase">{t(`${i18FileName}.fee.statusIsPaid`)}</div>
      </div>
    </div>
  );
}

export default FeeSuccess;
